export enum BusinessPayoutMethod {
  STANDARD = 'standard',
  INSTANT = 'instant'
}

export interface BusinessPayoutWithdraw {
  id: string;
}

export interface BusinessPayoutByWithdraw {
  method: BusinessPayoutMethod;
  displayAmount: number;
  netAmount: number;
}
